import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Input } from '../Input';
import { Select } from '../Select';
import { Text } from '../Text';
function clampPageNumber(pageNumber, totalCount, countPerPage) {
    return pageNumber === undefined
        ? 1
        : Math.max(Math.min(pageNumber, Math.ceil(totalCount / countPerPage)), 1);
}
/**
 - Pagination component for rendering a page of data
 - Can provide any array of data objects and the table will only render the columns provided in the column prop
 */
export const Pagination = ({ pageNumber, countPerPage, totalCount, loading, mobile, onChangeCountPerPage, onChangePageNumber }) => {
    const clampedPageNumber = clampPageNumber(pageNumber, totalCount, countPerPage);
    const [newPageNumber, setNewPageNumber] = useState(clampedPageNumber);
    const first = totalCount
        ? Math.min((clampedPageNumber - 1) * countPerPage + 1, totalCount)
        : 0;
    const last = totalCount
        ? Math.min(Math.max(0, first + countPerPage - 1), totalCount)
        : 0;
    const pageCount = Math.ceil(totalCount / countPerPage) || 1;
    useEffect(() => {
        setNewPageNumber(clampedPageNumber);
    }, [clampedPageNumber]);
    const handleChangeCountPerPage = (count) => {
        onChangeCountPerPage(parseInt(count));
    };
    const handleChangePageNumber = (page) => {
        setNewPageNumber(page !== '' ? parseInt(page) : page);
    };
    const handleSavePageNumber = () => {
        if (typeof newPageNumber === 'number')
            onChangePageNumber(clampPageNumber(newPageNumber, totalCount, countPerPage));
    };
    const handleSetFirstPage = () => {
        onChangePageNumber(1);
    };
    const handleSetPreviousPage = () => {
        if (clampedPageNumber > 1) {
            setNewPageNumber(clampedPageNumber - 1);
            onChangePageNumber(clampedPageNumber - 1);
        }
    };
    const handleSetLastPage = () => {
        onChangePageNumber(pageCount);
    };
    const handleSetNextPage = () => {
        if (clampedPageNumber < pageCount) {
            onChangePageNumber(clampedPageNumber + 1);
            setNewPageNumber(clampedPageNumber + 1);
        }
    };
    return (React.createElement("div", { className: "flex flex-row w-full py-2 px-4 flex-wrap bg-gray-300", "data-testid": "pagination" },
        !mobile && (React.createElement("div", { className: "flex-1" },
            React.createElement(Select, { className: "w-fit", options: [
                    { id: '20', label: '20 Per Page' },
                    { id: '50', label: '50 Per Page' },
                    { id: '100', label: '100 Per Page' }
                ], value: countPerPage.toString(), onChangeValue: handleChangeCountPerPage, hideErrorSection: true, placeholder: "Select Count Per Page", clearable: false }))),
        React.createElement("div", { className: `${mobile ? 'w-full ' : ''}flex-initial flex flex-row justify-center md:gap-1 align-middle` },
            React.createElement("div", { className: "h-full flex flex-row items-center", onClick: handleSetFirstPage },
                React.createElement(ChevronDoubleLeftIcon, { className: "text-blue-800 h-6 w-6 cursor-pointer" })),
            React.createElement("div", { className: "h-full flex flex-row items-center", onClick: handleSetPreviousPage },
                React.createElement(ChevronLeftIcon, { className: "text-blue-800 h-6 w-6 cursor-pointer" })),
            React.createElement("div", { className: "flex flex-row items-center gap-1" },
                React.createElement(Input, { "data-testid": "page-number", className: "w-10", value: newPageNumber.toString(), onChangeValue: handleChangePageNumber, onBlur: handleSavePageNumber, onPressEnter: handleSavePageNumber, hideErrorSection: true }),
                React.createElement(Text, { "data-testid": "of-pagecount", className: "h-7 items-center" },
                    "of ",
                    pageCount ?? 0)),
            React.createElement("div", { className: "h-full flex flex-row items-center", onClick: handleSetNextPage },
                React.createElement(ChevronRightIcon, { className: "text-blue-800 h-6 w-6 cursor-pointer" })),
            React.createElement("div", { className: "h-full flex flex-row items-center", onClick: handleSetLastPage },
                React.createElement(ChevronDoubleRightIcon, { className: "text-blue-800 h-6 w-6 cursor-pointer" }))),
        !mobile && (React.createElement(Text, { "data-testid": "records-count", className: "flex-1 justify-end items-center", textClassName: `${loading ? ' w-20' : ''}` }, loading ? React.createElement(Skeleton, null) : `${first}-${last} of ${totalCount ?? 0}`))));
};
export * from './index.types';
//# sourceMappingURL=index.js.map